import { render, staticRenderFns } from "./kenmB.vue?vue&type=template&id=d631ede4&scoped=true"
import script from "./kenmB.vue?vue&type=script&lang=js"
export * from "./kenmB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d631ede4",
  null
  
)

export default component.exports